import { DiscountDiscountType } from "../../dtos/offers";
import {
  OfferQuantityButtonType,
  UserInterfaceDto,
} from "../../dtos/user-interfaces";
import { WidgetDto } from "../../dtos/widgets";

import {
  ResolvedWidgetDeviceConfigType,
  WidgetConfigType,
  WidgetDeviceConfigType,
} from "./common";

export const QuantityButtonsVariantList = [
  "quantityButtonsWidget1",
  "quantityButtonsWidget4",
  "quantityButtonsWidgetClassic",
  "quantityButtonsWidgetCompact",
  "quantityButtonsWidgetImage",
] as const;

export type QuantityButtonsVariant =
  (typeof QuantityButtonsVariantList)[number];

export const QUANTITY_BUTTONS_VARIANT_NAMES: Record<
  QuantityButtonsVariant,
  string
> = {
  quantityButtonsWidgetClassic: "Classic list",
  quantityButtonsWidgetCompact: "Compact",
  quantityButtonsWidgetImage: "Image cards",
  quantityButtonsWidget1: "Buttons 1",
  quantityButtonsWidget4: "Buttons 4",
};

export type LayoutSettings = "row" | "column";

export type TypographySettings = {
  fontSize: string;
  fontStyle: string;
};
export const DefaultVariantOptionInfo = ["color", "size"] as const;
export type DefaultVariantOptionInfoType =
  (typeof DefaultVariantOptionInfo)[number];

export interface QuantityButtonsStyles {
  colors: {
    // TODO - CP this will no longer be used in new styles
    primary: string;
    secondary: string;
    border: string;
  };
  backgroundColors: {
    buttonInactiveBackground: string;
    buttonActiveBackground: string;
    buttonBorderColor: string;
    badgeColor: string;
    freeShippingBackground: string;
    freeGiftBackground: string;
  };
  textColors: {
    sectionTitle: string;
    buttonTitle: string;
    label: string;
    subtitle: string;
    price: string;
    comparePrice: string;
    badge: string;
    freeShippingLabel: string;
    freeGiftLabel: string;
    freeGiftCompareAtPrice: string;
  };
  typography: {
    sectionTitle: TypographySettings;
    subtitle: TypographySettings;
    buttonTitle: TypographySettings;
    price: TypographySettings;
    comparePrice: TypographySettings;
    label: TypographySettings;
    badge: TypographySettings;
    freeShippingLabel: TypographySettings;
    freeGiftLabel: TypographySettings;
    freeGiftCompareAtPrice: TypographySettings;
  };
  appearance: {
    cornerRadius: number;
    spacing: string;
    layout: "row" | "column";
  };
}

export type QuantityButtonsTextReplacements = {
  each?: string;
  save?: string;
  off?: string;
  percent?: string;
  fullPriceMessage?: string;
};

export interface QuantityButtonsVariables {
  buttons: OfferQuantityButtonType[];
  textReplacements?: QuantityButtonsTextReplacements; // TODO - CP no longer going to be used in new buttons, figure out deprecate note
  sectionTitle?: string;
}

export interface QuantityButtonsWidgetDto extends WidgetDto {
  widgetType: "quantityButtons";
  config: QuantityButtonsWidgetConfig;
}

export interface QuantityButtonsConfig {
  widget: QuantityButtonsWidgetConfig;
  discountType: DiscountDiscountType;
}

export type QuantityButtonsWidgetConfig = WidgetConfigType<
  QuantityButtonsVariant,
  QuantityButtonsStyles,
  QuantityButtonsVariables
>;

export type QuantityButtonsDeviceConfig = WidgetDeviceConfigType<
  QuantityButtonsVariant,
  QuantityButtonsStyles,
  QuantityButtonsVariables
>;

export type ResolvedQuantityButtonsDeviceConfig =
  ResolvedWidgetDeviceConfigType<
    QuantityButtonsVariant,
    QuantityButtonsStyles,
    QuantityButtonsVariables
  >;

export interface QuantityButtonsUserInterface
  extends Omit<
    UserInterfaceDto,
    "widget" | "desktopVariables" | "mobileVariables"
  > {
  widget?: QuantityButtonsWidgetDto;
  desktopVariables?: Partial<QuantityButtonsVariables>;
  mobileVariables?: Partial<QuantityButtonsVariables>;
}

export interface QuantityButtonsProduct {
  basePrice: number;
  formattedBasePrice: string;
  productId: string;
  variantId: string;
  productTitle?: string;
  comparePrice?: number;
}

export interface QuantityButtonsWidgetType {
  updateOrBuild(container: Element[]): Promise<boolean>;
}
